/* eslint-disable camelcase */
/* eslint-disable no-case-declarations */
import { useEffect, useState } from 'react';
import { fetchHolidays } from '../../../modules/api';
import { initialListingFilterObj } from '../../utils/constants';
import useFilters from '../../globalHooks/useFilters';

const useHolidayListing = (id, holidayStyles) => {
  const [holidays, setHolidays] = useState([]);

  const [rawHolidays, setRawHolidays] = useState([]);

  const [waiting, setWaiting] = useState(true);

  const [error, setError] = useState(null);

  const [destinations, setDestinations] = useState([]);

  const [travelTypes, setTravelTypes] = useState([]);

  const [activeFilters, setActiveFilters] = useState({
    ...initialListingFilterObj,
  });

  const [sort, setSort] = useState('popular');

  const [currentPage, setCurrentPage] = useState(0);

  const { filterTravelType } = useFilters(activeFilters);

  useEffect(() => {
    if (id && rawHolidays.length < 1) {
      (async () => {
        const feed = await getHolidaysFeed(id);

        setHolidays(feed);

        setRawHolidays(feed);

        setDestinations(getDestinations(feed));

        setTravelTypes(getTravelTypes(feed));
      })();
    }
  }, [id]);

  const getDestinations = (feed) => {
    let returner = [
      {
        display: 'All',
        slug: 'All',
        id: 0,
      },
    ];

    feed.forEach(({ destinations }, index) => {
      if (destinations) {
        destinations.forEach((destination) => {
          if (!returner.find(({ slug }) => slug === destination.slug)) {
            returner = [...returner, destination];
          }
        });
      }
    });

    return returner;
  };

  const getTravelTypes = (feed) => {
    let returner = [
      {
        display: 'All',
        slug: 'All',
        subtypeSlug: '',
      },
    ];

    feed.forEach(({ travel_type }) => {
      if (travel_type) {
        const combinedSlug = travel_type.subtypeSlug
          ? `${travel_type.slug}-${travel_type.subtypeSlug}`
          : travel_type.slug;

        const alreadyExists = returner.some(
          ({ slug, subtypeSlug }) =>
            slug === travel_type.slug &&
            (subtypeSlug === travel_type.subtypeSlug ||
              (subtypeSlug === '' && !travel_type.subtypeSlug))
        );

        if (!alreadyExists && combinedSlug !== '') {
          returner = [...returner, travel_type];
        }
      }
    });

    return returner;
  };

  useEffect(() => {
    let newHolidays = filterTravelType(rawHolidays);

    newHolidays = sortHolidays(sort, [...newHolidays]);

    setHolidays(newHolidays);

    setCurrentPage(0);
  }, [JSON.stringify(activeFilters), JSON.stringify(rawHolidays), sort]);

  const getHolidaysFeed = async (id = '') => {
    try {
      setWaiting(true);

      return await fetchHolidays(id, holidayStyles);
    } catch (error) {
      console.error('Can not get holidays feed', error);
      setError('An unexpected error has occurred');
    } finally {
      setWaiting(false);
    }
  };

  const sortHolidays = (sort, holidays) => {
    switch (sort) {
      case 'popular':
        return holidays.sort(
          (a, b) => parseInt(a.popularity, 10) - parseInt(b.popularity, 10)
        );
      case 'new':
        return holidays;
      case 'price_low':
        // use low price
        return holidays.sort((a, b) => (a.price.slug > b.price.slug ? 1 : -1));
      case 'price_high':
        // use high price
        return holidays.sort((a, b) => (b.price.slug > a.price.slug ? 1 : -1));
      case 'a-z':
        // alphabet ascending
        return holidays.sort((a, b) =>
          a.title.display.charAt(0).toLowerCase() >
          b.title.display.charAt(0).toLowerCase()
            ? 1
            : -1
        );
      case 'z-a':
        // alphabet descending
        return holidays.sort((a, b) =>
          b.title.display.charAt(0).toLowerCase() >
          a.title.display.charAt(0).toLowerCase()
            ? 1
            : -1
        );
      default:
        return holidays;
    }
  };

  return {
    waiting,
    holidays,
    rawHolidays,
    error,
    setError,
    destinations,
    travelTypes,
    activeFilters,
    setActiveFilters,
    setSort,
    currentPage,
    setCurrentPage,
  };
};

export default useHolidayListing;
